import {React} from 'common'
import {Styles, Texts} from 'appearance'
import Toolbar from '@mui/material/Toolbar'
import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import MuiAppBar from '@mui/material/AppBar'
import LanguageMenu from 'components/Page/Header/LanguageMenu'
import MobileMenu from 'components/Page/Header/MobileMenu'
import MainMenuButton from './Header/MainMenuButton'
import LanguageMenuButton from './Header/LanguageMenuButton'
import HeaderActions from './Header/HeaderActions'
import MobileMenuButton from './Header/MobileMenuButton'
import MainMenu from './Header/MainMenu'
import {useI18n} from 'store/Store'
import useHeaderMenu from 'logic/Menu/useHeaderMenu'
import {Link, Typography, Stack} from '@mui/material'
import {formatLoggedInUser} from 'services/utils/data'
import {getLocale} from 'localization/i18n'

const Header = ({toggleDrawer, open}) => {
    const {i18n} = useI18n()
    const {locale} = getLocale()

    const {
        anchors,
        handleSetLanguage,
        isMenuOpen,
        handleOpenMenu,
        handleCloseMenu,
        loggedInEmail,
        user,
    } = useHeaderMenu()

    const menuId = 'primary-search-account-menu'
    const languageMenuId = 'primary-search-account-menu-language'
    const mobileMenuId = 'primary-search-account-menu-mobile'

    const userName = formatLoggedInUser(user, locale)

    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar position="fixed" open={open}>
                <Toolbar>
                    <MainMenuButton toggleDrawer={toggleDrawer} />
                    <Link href="/" underline="none">
                        <Texts.Title>{i18n.t('header.title')}</Texts.Title>
                    </Link>
                    <Box sx={{flexGrow: 1}} />

                    {user && (
                        <UserDisplay>
                            <UserName variant="subtitle2">
                                {i18n.t('header.loggedInAs')}: {userName}
                            </UserName>
                        </UserDisplay>
                    )}

                    <LanguageMenuButton
                        menuId={languageMenuId}
                        handleOpenMenu={handleOpenMenu}
                    />

                    <HeaderActions
                        menuId={menuId}
                        handleOpenMenu={handleOpenMenu}
                    />
                    <MobileMenuButton
                        mobileMenuId={mobileMenuId}
                        handleOpenMenu={handleOpenMenu}
                    />
                </Toolbar>
            </AppBar>
            <MainMenu
                menuId={menuId}
                anchorEl={anchors.profile}
                isMenuOpen={isMenuOpen}
                handleCloseMenu={handleCloseMenu}
                setMobileMoreAnchorEl={handleOpenMenu}
                loggedInEmail={loggedInEmail}
            />
            <MobileMenu
                mobileMenuId={mobileMenuId}
                handleCloseMenu={handleCloseMenu}
                mobileMoreAnchorEl={anchors.mobile}
                isMenuOpen={isMenuOpen}
            />
            <LanguageMenu
                isOpen={isMenuOpen('language')}
                languageAnchorEl={anchors.language}
                handleCloseMenu={handleCloseMenu}
                handleSetLanguage={handleSetLanguage}
            />
        </Box>
    )
}

export default Header

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: Styles.DRAWER_WIDTH,
        width: `calc(100% - ${Styles.DRAWER_WIDTH}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}))

const UserDisplay = styled(Stack)`
    display: none;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    margin-right: 16px;
    padding: 6px 12px;
    border-radius: 20px;
    background-color: rgba(255, 255, 255, 0.1);
    transition: background-color 0.2s ease-in-out;

    &:hover {
        background-color: rgba(255, 255, 255, 0.15);
    }

    @media (min-width: 900px) {
        display: flex;
    }
`

const UserName = styled(Typography)`
    color: ${({theme}) => theme.palette.common.white};
    font-weight: 500;
    white-space: nowrap;
`
